











import { Component, Prop, Vue } from 'vue-property-decorator'
import { PipelinePhaseCategory, ReferralCount, ReferralStatus } from '@/api/types'
import { namespace } from 'vuex-class'
import { ReferralStats } from '@/api/model/referral-stats'
import { PipelinePhase } from '@/api/model/pipeline-phase'

const referrals = namespace('referrals')

@Component
export default class StatusTabs extends Vue {
    @Prop({ required: true }) readonly status!: ReferralStatus
    @Prop() readonly phase!: PipelinePhase
    @referrals.State readonly referralCounts!: ReferralCount
    @referrals.State readonly referralStats!: ReferralStats
    @referrals.State readonly statusFilter!: string
    @referrals.State readonly pipelineFilter!: string
    @referrals.State phaseFilter!: PipelinePhase
    @referrals.State readonly phaseCategoryFilter!: PipelinePhaseCategory
    @referrals.Action applyStatusFilter!: ({ statusFilter: string }) => Promise<void>
    @referrals.Action applyPipelinePhaseFilter!: ({ phase: PipelinePhase }) => Promise<void>


    get title(): string {
        if (!this.status) {
            return this.$t('navigation.leads_menu.statuses.open').toString()
        }

        return this.$t(`navigation.leads_menu.statuses.${this.status}`).toString()
    }

    get count(): number {
        return this.countForStatus(this.status)
    }

    get countBackgroundColor(): string {
        return this.colorForStatus(this.status, .25)
    }

    get countColor(): string {
        return this.colorForStatus(this.status)
    }

    get active(): boolean {
        if (this.status === ReferralStatus.OPEN && this.phaseCategoryFilter) {
            return false
        }

        if (this.phaseFilter) {
            return false
        }

        return this.status === this.statusFilter
    }

    activate(): void {
        this.applyStatusFilter({
            statusFilter: this.status,
        })
    }

    countForStatus(status: string): number {
        const counts = {
            null: this.referralCounts.statusAll,
            [ReferralStatus.NEW]: this.referralCounts.statusNew,
            [ReferralStatus.UNREACHABLE]: this.referralCounts.statusUnreachable,
            [ReferralStatus.PENDING]: this.referralCounts.statusPending,
            [ReferralStatus.APPOINTMENT]: this.referralCounts.statusAppointment,
            [ReferralStatus.PROPOSAL]: this.referralCounts.statusProposal,
            [ReferralStatus.ON_HOLD]: this.referralCounts.statusOnHold,
            [ReferralStatus.SUCCESSFUL]: this.referralCounts.statusSuccessful,
            [ReferralStatus.CLOSED]: this.referralCounts.statusClosed,
            [ReferralStatus.PROCESSED]: this.referralCounts.statusProcessed,
        }

        const entry = this.referralStats.countsPerStatus
            .find(v => v.status === status)

        return entry ? entry.count : counts[status]
    }

    colorForStatus(status: string, opacity: number = 1): string {
        switch (status) {
            case ReferralStatus.OPEN: return `rgba(96, 96, 96, ${opacity})`
            case ReferralStatus.NEW: return `rgba(19, 210, 197, ${opacity})`
            case ReferralStatus.UNREACHABLE: return `rgba(235, 89, 140, ${opacity})`
            case ReferralStatus.PENDING: return `rgba(247, 131, 35, ${opacity})`
            case ReferralStatus.APPOINTMENT: return `rgba(66, 153, 225, ${opacity})`
            case ReferralStatus.PROPOSAL: return `rgba(145, 105, 226, ${opacity})`
            case ReferralStatus.ON_HOLD: return `rgba(231, 220, 30, ${opacity})`
            case ReferralStatus.SUCCESSFUL: return `rgba(0, 163, 137, ${opacity})`
            case ReferralStatus.CLOSED: return `rgba(222, 64, 119, ${opacity})`
            case ReferralStatus.PROCESSED: return `rgba(96, 96, 96, ${opacity})`
            default: return `rgba(169, 50, 38, ${opacity})`
        }
    }
}
